var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cardToContentCollectionCard } from "contentCollection/cardMapping";
import { CardHorizontal } from "contentCollection/horizontal/CardHorizontal";
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { Tracking } from "core/tracking";
import { config, truncate } from "core/utils";
import React, { forwardRef } from "react";
import styled from "styled-components";
import { View } from "./View";
export var Provider = forwardRef(function (_a, ref) {
    var componentId = _a.componentId, title = _a.title, items = _a.items, currentPos = _a.currentPos, uuid = _a.uuid, listName = _a.listName, trackingEnabled = _a.trackingEnabled, callToAction = _a.callToAction;
    var _b = useEnteredViewport(config.tracking.impressionThreshold.default), refViewport = _b.ref, enteredViewport = _b.enteredViewport;
    if (trackingEnabled && enteredViewport) {
        Tracking.trackCollection(listName, items);
    }
    return (React.createElement("section", { ref: ref },
        React.createElement(View, { ref: refViewport, title: title, uuid: uuid, currentPos: currentPos, componentId: componentId, callToAction: callToAction }, function (createClickHandlers) {
            return items.map(function (reference, index) {
                var card = cardToContentCollectionCard(truncateTitle(reference));
                return (React.createElement(StyledCard, { data: card, clickHandlers: card.kind !== "Text"
                        ? createClickHandlers({
                            item: card,
                            position: index + 1,
                            listName: listName,
                        })
                        : undefined, listName: listName, position: index + 1 }));
            });
        })));
});
function truncateTitle(data) {
    return __assign(__assign({}, data), { title: truncate(config.characterLimit.card, data.title) });
}
var StyledCard = styled(CardHorizontal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  \n  &:focus{\n    border-radius: 0.5rem;\n  }\n"], ["\n  width: 100%;\n  \n  &:focus{\n    border-radius: 0.5rem;\n  }\n"])));
var templateObject_1;
